import { ContactInfo, NavigationItem, OpeningHours, Address, SocialMedia } from '../types';

export const CONTACT_INFO: ContactInfo[] = [
  { phone: '661 628 174', name: 'Patrycja' },
  { phone: '601 526 320', name: 'Grzegorz' }
];

export const ADDRESS: Address = {
  street: 'ul. Piastowska 6',
  city: 'Recz',
  postalCode: '73-210'
};

export const OPENING_HOURS: OpeningHours[] = [
  { day: 'Poniedziałek - Piątek', hours: '08:00 - 19:00' },
  { day: 'Sobota', hours: '09:00 - 13:00' },
  { day: 'Niedziela', hours: 'nieczynne' }
];

export const MAIN_NAVIGATION: NavigationItem[] = [
  { href: '/o-nas', text: 'O nas' },
  { href: '/oferta', text: 'Oferta' },
  { href: '/certyfikaty', text: 'Certyfikaty' },
  { href: '/cennik', text: 'Cennik' },
  { href: '/kontakt', text: 'Kontakt' },
  { href: '/informacje-dla-pacjenta', text: 'Dla pacjenta' }
];

export const TOPBAR_NAVIGATION: NavigationItem[] = [
  { href: '/polityka-cookies', text: 'Polityka prywatności' },
  { href: '/informacje-rodo', text: 'Przepisy RODO' },
  { href: 'https://www.facebook.com/fizjofit.pabich/', text: 'Facebook', external: true },
  { href: '/informacje-dla-pacjenta', text: 'Informacje dla Pacjenta' }
];

export const SOCIAL_MEDIA: SocialMedia[] = [
  {
    platform: 'Facebook',
    url: 'https://www.facebook.com/fizjofit.pabich/',
    icon: 'fab fa-facebook-f'
  }
];

export const EMAILS = [
  'patrycja@fizjoterapia-pabich.pl',
  'grzegorz@fizjoterapia-pabich.pl'
];

export const SITE_CONFIG = {
  title: 'Fizjofit - P.G Pabich',
  subtitle: 'Fizjoterapia i Rehabilitacja w Reczu',
  logo: '/img/logo_new.png',
  favicon: '/img/favicon.png',
  mapUrl: 'https://maps.app.goo.gl/U1RAV35XXq2MCYnT8',
  facebookPageId: '1978942165722540',
  messengerUrl: 'https://m.me/fizjofit.pabich'
};
